module.exports = __webpack_public_path__ + "static/media/HeroBackground-Option1-01.d4bd9327.png";